module.exports = __webpack_public_path__ + "static/media/Stellar Max Queen Headboard - 155 cm_Natural.fe466fa5.png";